import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=527cfc34&scoped=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&lang=js"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=527cfc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cfc34",
  null
  
)

export default component.exports